import { useNavigate } from "react-router-dom";
import { Trash2, Sparkles, Wrench, Trees, Paintbrush, Truck, Droplets, Zap, Fan, ArrowRight } from "lucide-react";
import { getServiceBySlug } from "@/lib/services";
import { Container } from "./public/kit";
import { track } from "@/lib/analytics";

const ICONS = { Trash2, Sparkles, Wrench, Trees, Paintbrush, Truck, Droplets, Zap, Fan };
const FEATURED_SLUGS = ["junk-removal", "house-cleaning", "handyman", "landscaping", "painting", "moving-help", "plumbing", "electrical", "hvac"];

// Pulled dynamically from the existing Brivio service catalog (lib/services.js).
const services = FEATURED_SLUGS.map((slug) => getServiceBySlug(slug)).filter(Boolean);

export const PopularServices = () => {
  const navigate = useNavigate();
  const go = (svc) => navigate(svc.slug === "junk-removal" ? "/junk-removal" : `/app/get-help?service=${svc.slug}`);
  const goRequest = () => { track("click_post_request_free", { cta: "services-get-quotes" }); navigate("/app/get-help"); };

  return (
    <section id="popular-services" className="bg-[var(--b2-surface)] py-14 md:py-24 border-t border-[var(--b2-border)]/60" data-testid="popular-services-section">
      <div className="max-w-[1300px] mx-auto px-5 md:px-10">
        <div className="max-w-xl mx-auto text-center mb-11">
          <h2 className="font-display text-[32px] md:text-[44px] font-extrabold tracking-tight text-[var(--b2-navy)]">What can we help you with?</h2>
          <p className="mt-3 text-[var(--b2-ink-soft)] text-base md:text-lg">Pick a service to get free local quotes.</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3.5 md:gap-6 max-w-3xl mx-auto">
          {services.map((svc, i) => {
            const Icon = ICONS[svc.icon] || Wrench;
            return (
              <button key={svc.slug} data-testid={`popular-service-${i}`} onClick={() => go(svc)}
                className="group flex flex-col items-center justify-center gap-3 bg-white rounded-[22px] border border-[var(--b2-border)]/70 px-3 py-6 md:py-8 shadow-[0_10px_28px_rgba(10,21,48,0.05)] transition-all duration-200 hover:-translate-y-1.5 hover:border-[var(--b2-green)]/60 hover:shadow-[0_24px_54px_rgba(22,163,74,0.16)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--b2-green)]">
                <span className="inline-flex items-center justify-center w-[60px] h-[60px] md:w-[76px] md:h-[76px] rounded-[20px] bg-[var(--b2-green-soft)] text-[var(--b2-green)] group-hover:bg-[var(--b2-green)] group-hover:text-white group-hover:scale-105 transition-all duration-200">
                  <Icon className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.7} />
                </span>
                <span className="font-display font-bold text-[var(--b2-navy)] text-[14px] md:text-[17px] leading-tight text-center">{svc.label}</span>
              </button>
            );
          })}
        </div>
        <div className="mt-10 text-center">
          <button onClick={goRequest} data-testid="services-more-cta"
            className="inline-flex items-center gap-2 font-semibold text-[var(--b2-green)] hover:text-[var(--b2-green-hover)] transition-colors">
            Something else? Tell us what you need <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
